<template>
  <div
    v-if="data"
    :style="imageClassData"
    class="q-image-container animate__animated"
    :class="[data.animateName]"
  >
    <img class="q-image" v-if="data.url" :src="data.url" alt="" />
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      checked: false
    }
  },
  computed: {
    /* 图片位置信息 */
    imageClassData() {
      let obj = {}
      Object.keys(this.data).map((key) => {
        obj[key] = this.data[key] + 'px'
      })
      return obj
    }
  },
  created() {},
  methods: {}
}
</script>
<style lang="scss" scoped>
.q-image-container {
  position: absolute;

  .q-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>
